// import {  Linkdin, Twiter } from "lucide-react";

export const Contact = ({ ref, darkMode }) => {
  return (
    <div
      ref={ref}
      id="contact"
      className={` relative  h-screen flex flex-col justify-center 
        px-8  sm:px-16   md:px-24 xl:px-40 2xl:px-52
         ${darkMode ? "text-white" : "text-black"}`}
    >
      <div className="h-1/2">
        <h1
          className={`text-3xl font-serif py-2 ${
            darkMode ? "text-white" : "text-black"
          }`}
        >
          Contact!
        </h1>
        <p className=" max-w-[500px] font-light text-gray-400 py-2">
          Feel free to reach out if you want a to build something together, have
          a question, or just want to connect.
        </p>
        <a
          className=" text-base font-serif underline "
          href="mailito:youssefichiba@gmail.com"
        >
          youssefichiba@gmail.com
        </a>
        <div className=" mt-2 flex gap-4">
          <a href="https://www.linkedin.com/in/youssef-ichiba-61921b137/">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M5.1483 22.7495H0.379911V7.56082H5.1483V22.7495ZM2.76154 5.48894C1.23676 5.48894 0 4.23973 0 2.73152C1.09137e-08 2.00708 0.290947 1.3123 0.808836 0.800045C1.32673 0.287785 2.02913 0 2.76154 0C3.49395 0 4.19635 0.287785 4.71424 0.800045C5.23213 1.3123 5.52308 2.00708 5.52308 2.73152C5.52308 4.23973 4.2858 5.48894 2.76154 5.48894ZM22.9949 22.7495H18.2367V15.3557C18.2367 13.5936 18.2008 11.3339 15.7576 11.3339C13.2784 11.3339 12.8985 13.2483 12.8985 15.2288V22.7495H8.13522V7.56082H12.7085V9.6327H12.7753C13.4119 8.43934 14.9669 7.17996 17.287 7.17996C22.1129 7.17996 23 10.3233 23 14.4061V22.7495H22.9949Z" />
            </svg>
          </a>
          <a href="https://x.com/ichiba_youssef">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="currentColor"
              href="https://x.com/?lang=en&mx=2"
            >
              <path d="M18.244 2H22L14.924 10.697L23.5 22H16.591L11.36 15.182L5.314 22H1.556L9.128 12.697L1 2H8.091L12.887 8.316L18.244 2ZM16.984 20H18.791L6.45 3.93H4.514L16.984 20Z" />
            </svg>
          </a>
          <a href="https://github.com/Yichiba">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M8.02742 19.4043C8.02742 19.502 7.91613 19.5801 7.77581 19.5801C7.61613 19.5947 7.50484 19.5166 7.50484 19.4043C7.50484 19.3066 7.61613 19.2285 7.75645 19.2285C7.90161 19.2139 8.02742 19.292 8.02742 19.4043ZM6.52258 19.1846C6.48871 19.2822 6.58548 19.3945 6.73065 19.4238C6.85645 19.4727 7.00161 19.4238 7.03064 19.3262C7.05968 19.2285 6.96774 19.1162 6.82258 19.0723C6.69677 19.0381 6.55645 19.0869 6.52258 19.1846ZM8.66129 19.1016C8.52097 19.1357 8.42419 19.2285 8.43871 19.3408C8.45323 19.4385 8.57903 19.502 8.72419 19.4678C8.86452 19.4336 8.96129 19.3408 8.94677 19.2432C8.93226 19.1504 8.80161 19.0869 8.66129 19.1016ZM11.8452 0.390625C5.13387 0.390625 0 5.53223 0 12.3047C0 17.7197 3.37742 22.3535 8.20161 23.9844C8.82097 24.0967 9.03871 23.7109 9.03871 23.3936C9.03871 23.0908 9.02419 21.4209 9.02419 20.3955C9.02419 20.3955 5.6371 21.1279 4.92581 18.9404C4.92581 18.9404 4.37419 17.5195 3.58065 17.1533C3.58065 17.1533 2.47258 16.3867 3.65806 16.4014C3.65806 16.4014 4.8629 16.499 5.52581 17.6611C6.58548 19.5459 8.36129 19.0039 9.05323 18.6816C9.16452 17.9004 9.47903 17.3584 9.82742 17.0361C7.12258 16.7334 4.39355 16.3379 4.39355 11.6406C4.39355 10.2979 4.76129 9.62402 5.53548 8.76465C5.40968 8.44727 4.99839 7.13867 5.66129 5.44922C6.67258 5.13184 9 6.76758 9 6.76758C9.96774 6.49414 11.0081 6.35254 12.0387 6.35254C13.0694 6.35254 14.1097 6.49414 15.0774 6.76758C15.0774 6.76758 17.4048 5.12695 18.4161 5.44922C19.079 7.14355 18.6677 8.44727 18.5419 8.76465C19.3161 9.62891 19.7903 10.3027 19.7903 11.6406C19.7903 16.3525 16.9403 16.7285 14.2355 17.0361C14.6806 17.4219 15.0581 18.1543 15.0581 19.3018C15.0581 20.9473 15.0435 22.9834 15.0435 23.3838C15.0435 23.7012 15.2661 24.0869 15.8806 23.9746C20.7194 22.3535 24 17.7197 24 12.3047C24 5.53223 18.5565 0.390625 11.8452 0.390625ZM4.70323 17.2314C4.64032 17.2803 4.65484 17.3926 4.7371 17.4854C4.81452 17.5635 4.92581 17.5977 4.98871 17.5342C5.05161 17.4854 5.0371 17.373 4.95484 17.2803C4.87742 17.2021 4.76613 17.168 4.70323 17.2314ZM4.18064 16.8359C4.14677 16.8994 4.19516 16.9775 4.29194 17.0264C4.36935 17.0752 4.46613 17.0605 4.5 16.9922C4.53387 16.9287 4.48548 16.8506 4.38871 16.8018C4.29194 16.7725 4.21452 16.7871 4.18064 16.8359ZM5.74839 18.5742C5.67097 18.6377 5.7 18.7842 5.81129 18.877C5.92258 18.9893 6.0629 19.0039 6.12581 18.9258C6.18871 18.8623 6.15968 18.7158 6.0629 18.623C5.95645 18.5107 5.81129 18.4961 5.74839 18.5742ZM5.19677 17.8564C5.11935 17.9053 5.11935 18.0322 5.19677 18.1445C5.27419 18.2568 5.40484 18.3057 5.46774 18.2568C5.54516 18.1934 5.54516 18.0664 5.46774 17.9541C5.4 17.8418 5.27419 17.793 5.19677 17.8564Z" />
            </svg>
          </a>
        </div>
      </div>
      <div
        className={` md:hidden absolute left-0 flex justify-center w-screen  bottom-10 font-serif ${
          darkMode ? "text-white" : "text-black"
        }`}
      >
        <div className=" text-center  font-extralight text-sm mt-auto">
          Handcrafted by me © 2024.
          <br />
          Design prototype is available on{" "}
          <a
            className="text-gray-400"
            href="https://www.figma.com/design/K5yX0EjvrIfGmVtOCFuy9U/Portfolio-Minimal?node-id=44-38&t=ivH8zhg2BMty2niu-0"
          >
            Figma
          </a>
        </div>
      </div>
    </div>
  );
};







